import * as React from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import type { IUpwardForecastHistoryItem } from 'core/api/rest/queries/upward-forecast-history'
import DateUtils from 'core/utils/date'
import { useTranslation } from 'react-i18next'

const HistoryListItem: React.FunctionComponent<IUpwardForecastHistoryItem> = React.memo(({ date, activated }) => {
  const { t } = useTranslation()

  return (
    <ListItem alignItems="flex-start">
      <ListItemIcon>
        <span className="material-icons-outlined notranslate" style={{ color: '#3D9ACC' }}>
          event_note
        </span>
      </ListItemIcon>
      <ListItemText
        primary={DateUtils.dayToYearMonthLabel(DateUtils.formatDate(new Date(date)))}
        secondary={activated ? t('activated') : t('deactivated')}
        secondaryTypographyProps={{ style: { overflowWrap: 'break-word' } }}
      />
    </ListItem>
  )
})

export default HistoryListItem
